<template>
  <div :loading="loading" class="app-container">
    <div class="fixedButton">
      <vxe-button class="examineButton" @click="ReturnFun">返回</vxe-button>
      <vxe-button v-waves class="examineButton" status="success" @click="submint(0)">保存</vxe-button>
      <vxe-button v-waves class="examineButton" status="primary" @click="submint(1)">保存并发布</vxe-button>
    </div>
    <div class="CertificateReleaseApplicationBox scrollBars ActivityPlanReviewExamine" :style="`height:${$store.state.app.height - 70}px;`">
      <BasicInformation
        ref="BasicInformation"
        :activity.sync="activity"
        :class-type.sync="classType"
      />
      <reimburseInformation :activity.sync="activity" />
      <dealerList ref="dealerListDom" :model-table.sync="modelTable" :act-plan.sync="activity" />
    </div>
  </div>
</template>

<script>
import waves from '@/directive/waves' // waves directive
import { findById, saveActPlan, saveDealers } from '@/api/actPlan'
import dealerList from './components/dealerList.vue'
import BasicInformation from './components/BasicInformation.vue'
import reimburseInformation from './components/reimburseInformation.vue'

const defaultActivity = {
  id: '',
  actName: '', // 活动名称
  budgetTypeCode: '', // 预算类型编码
  budgetTypeName: '',
  oneLevelCode: '', // 一级来源编码
  oneLevelName: '',
  twoLevelCode: '', // 二级来源编码
  twoLevelName: '',
  threeLevelCode: '', // 三级来源编码
  threeLevelName: '',
  fourLevelCode: '', // 四级来源编码
  fourLevelName: '',
  fiveLevelCode: '', // 五级来源编码
  fiveLevelName: '',
  planStatus: 0, // 活动计划状态:0待发布，1已发布，2已失效
  planStartTime: '', // 计划生效时间
  planEndTime: '', // "计划失效时间/计划结束时间
  type: 1, // 计划类型 0大区-区域基金 1总部
  planCode: '', // 活动编码
  remarks: '', // 备注
  writeOffAnnex: '',
  writeOffInvoices: '',
  strainsCarCode: '',
  strainsCarName: ''
}

export default {
  name: 'EditActivity',
  components: { BasicInformation, dealerList, reimburseInformation },
  directives: { waves },
  data() {
    return {
      loading: false,
      activity: Object.assign({}, defaultActivity),
      modelTable: {
        data: [],
        loading: false,
        selection: []
      },
      classType: {}
    }
  },
  created() {
    this.activity.id = this.$route.params.id
    if (this.$route.params.id) {
      this.getActById() // 获取活动
    }
  },
  methods: {
    // 获取活动详情
    getActById() {
      const id = this.activity.id
      this.loading = true
      findById(id).then(res => {
        if (res.code === 1 && res.data) {
          this.activity = res.data
          this.loading = false
          this.$nextTick(() => {
            this.$refs.BasicInformation.findClassByCode(this.activity.fiveLevelCode)
          })
        } else {
          this.$message.error(res.message)
        }
      })
    },
    submint(status) {
      this.$refs['BasicInformation'].$children[0].validate(valid => {
        if (valid) {
          this.$refs['dealerListDom'].$refs['OBform'].validate(val => {
            if (!val) {
              this.$message.error('完善必填项！')
              return
            }
            if (this.classType.belongClassCode === 'CJ') {
              this.$message.error('来源分类只能为终端类，请重新选择活动来源')
              return
            }
            // 必须有一条
            if (this.modelTable.data < 1) {
              this.$message.error('下发经销商不能为空！')
              return
            }
            this.activity.planStatus = status
            const data = Object.assign({}, this.activity)
            this.loading = true
            saveActPlan(data).then(res => {
              if (res.code === 1 && res.data) {
                this.activity = res.data
                this.loading = false
                this.addBatchActplanDealer(status)
              } else {
                this.loading = false
                this.$message.error(res.message)
              }
            })
          })
        } else {
          this.$message.error('请检查表单，完成所有必填内容！')
          return
        }
      })
    },
    // 保存下发活动的经销商
    addBatchActplanDealer(status) {
      const data = {
        planId: this.activity.id,
        dealers: this.modelTable.data,
        actName: this.activity.actName
      }
      this.loading = true
      saveDealers(data).then(res => {
        if (res.code === 1) {
          this.loading = false
          if (status === 0) {
            this.$message.success('保存成功')
          } else {
            this.$message.success('发布成功')
          }
          this.ReturnFun()
        } else {
          this.loading = false
          this.$message.error(res.message)
        }
      })
    },
    ReturnFun() {
      this.$closePage('/terminalActivity/addActivity', '/terminalActivity/planDelivery')
    }
  }
}
</script>
<style lang="less">
.fixedButton {
  width: 100%;
  margin: 0;
  padding: 10px 5px 5px;
  .examineButton {
    margin: 0 10px 0 0;
  }
}
.CertificateReleaseApplicationBox {
  width: 100%;
  overflow: auto;
  // padding: 0 5px;
  .elcolSpan {
    font-size: 12px;
    color: #606266;
    text-align: center;
  }
  .budgetBox {
    margin: 0 0 5px 0;
  }
}
.editActivity {
  padding: 10px 30px;
}
.item-line {
  margin: 0;
  padding: 0px 20px;
  width: 100%;
  background: #0a76a4;
  color: #ffffff;
  height: 30px;
  line-height: 30px;
}
.Activity {
  margin: 0 37px;
  padding: 10px 0;
}
.usereq {
  .el-row {
    margin: 5px 0 !important;
  }
  .grid-content,
  .grid-Prohibit {
    text-align: center;
    font-size: 16px;
    border-radius: 4px;
    min-height: 36px;
  }
  .grid-content .el-checkbox__label {
    font-size: 16px;
  }
  .left_content {
    height: 80%;
    padding: 0 10px 10px 10px;
    overflow-y: auto;
    border-radius: 5px;
  }
  .center_content {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
  }
  .el-select.el-input--small .el-input__inner {
    color: #616b80;
    width: 100%;
    background: #152841;
    border-color: #152841;
    border-radius: 5px;
  }
  .el-checkbox-group .el-checkbox__label {
    display: none;
  }
  .center {
    text-align: center;
  }
  .center_content_r {
    width: 90%;
    height: 200px;
    margin-top: 200px;
  }
  .rule_btn {
    width: 100%;
    height: 60px;
    float: left;
    border: none;
  }
  .rule_btn_left,
  .rule_btn_right {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
  }
}
</style>
